module.exports = __webpack_public_path__ + "img/3.2_Russian_road_sign.63e1f4cf.svg";